var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"dashboard"}},[_c('section',{attrs:{"id":"content"}},[_c('div',{staticClass:"container"},[_c('TituloPagina',{attrs:{"titulo":"Acesso restrito"}}),_vm._v(" "),_c('p',[_vm._v("Você não tem acesso a essa funcionalidade do sistema, por favor entre em contato com a Segasp.")])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-be1ebbce","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/auth/Page403.vue
// module id = null
// module chunks = 